import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label, Row, Col, Form} from 'reactstrap';
import FormWrapper from './../../../commonComponents/formWrapper/FormWrapper.container';

import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";

class RemoveCommissionModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="commission-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <FormWrapper successMessage={_.get(this.props.translation, 'commissions.remove_commission_success_message')}>
                <Form>
                    <Label>
                        {_.get(this.props.translation, 'commissions.remove_commission_alert')}
                    </Label>
                    <Row className="modal-form-field-container">
                        <Col sm={6}>
                            {_.get(this.props.translation, sharedLabelsPath.name_label)}:
                        </Col>
                        <Col>
                            {this.props.data.name}
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={6}>
                            {_.get(this.props.translation, sharedLabelsPath.continent_label)}:
                        </Col>
                        <Col>
                            {_.get(this.props.translation, 'continents.' + this.props.data.continent)}
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={6}>
                            {_.get(this.props.translation, 'commissions.countries_label')}:
                        </Col>
                        <Col>
                            <div className="countries-container">
                                {
                                    _.map(this.props.data.countries, (country, id) => {
                                        return (
                                            <div className="country-item" key={id}>
                                                {_.get(this.props.translation, 'countries.' + country)}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={6}>
                            {_.get(this.props.translation, 'commissions.commission_label')}:
                        </Col>
                        <Col>
                            {this.props.data.commission + '%'}
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={6}>
                            {_.get(this.props.translation, 'commissions.date_from_label')}:
                        </Col>
                        <Col>
                            {this.props.data.dateFrom}
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={6}>
                            {_.get(this.props.translation, 'commissions.date_to_label')}:
                        </Col>
                        <Col>
                            {this.props.data.dateTo}
                        </Col>
                    </Row>
                    <div className="modal-buttons-container">
                        <Button color="secondary"
                                onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                        <Button className="olive-green-btn"
                                onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                    </div>
                </Form>
            </FormWrapper>
        );
    }

    handleRemove = (e) => {
        e.preventDefault();

        this.props.onCommissionRemove(this.props.data.id);
    };

    handleCancel = () => {
        this.props.onCancel();
    };
}

RemoveCommissionModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onCommissionRemove: PropTypes.func,
    onCancel: PropTypes.func
};

export default RemoveCommissionModal;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/commissionsModal/removeCommissionModal/RemoveCommissionModal.js